import Customer from "./-components/Customer/Customer";
import { useSettingStore } from "../../store/useSettingStore";
import Word from "./-components/Word/Word";
import Goods from "./-components/Goods/Goods";

const Settings = () => {
    const { selectedCategory } = useSettingStore();

    return selectedCategory === "고객" ? <Customer /> : selectedCategory === "경조사어" ? <Word /> : <Goods />;
};

export default Settings;
